import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { CurrencyAmountDisplay } from 'src/app/shared/utils/currency/currency-format';
import { GameInterfaceState } from 'src/app/shared/models/game/game-interface-state';
import { GameId } from 'src/app/shared/models/game/game-id';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { ThemePipe } from 'src/app/core/pipes/theme.pipe';
import { CurrencyIconComponent } from 'src/app/ui/currency/currency-icon/currency-icon.component';
import { NgStyle } from '@angular/common';
import { NavButtonComponent } from 'src/app/ui/buttons/nav-button/nav-button.component';

@Component({
  selector: 'app-game-replay',
  templateUrl: './game-replay.component.html',
  styleUrls: ['./game-replay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, NavButtonComponent, NgStyle, CurrencyIconComponent, ThemePipe],
})
export class GameReplayComponent {
  readonly gameId = input.required<GameId>();
  readonly gameInterfaceState = input.required<GameInterfaceState>();
  readonly reward = input<{
    primary: CurrencyAmountDisplay;
    secondary: CurrencyAmountDisplay;
  }>();
  readonly roomId = input<string>();

  readonly closeClicked = output<void>();

  private translocoService = inject(TranslocoService);
  themeService = inject(ThemeService);

  GameInterfaceState = GameInterfaceState;

  readonly prizeStyles: [string, string][] = [
    ['text-color', 'replay-header-prize'],
    ['type', 'replay-header-prize'],
  ];

  readonly scorePillStyles: [string, string][] = [
    ['background', 'pill-score'],
    ['border-radius', 'pill-score'],
    ['text-color', 'pill-score-label'],
    ['type', 'pill-score-label'],
  ];

  readonly roomStyles: [string, string][] = [
    ['text-color', 'replay-header-matchid'],
    ['type', 'replay-header-matchid'],
  ];

  get hasSecondaryCurrency(): boolean {
    return this.themeService.hasSecondaryCurrency;
  }

  onCloseClicked() {
    this.closeClicked.emit();
  }
}
